import { BomImage } from "../BomImage";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { X, Upload, Image as ImageIcon } from "lucide-react";

export function BomImageField({ imageUrl, onChange, onFile }) {
  return (
    <div className="space-y-1.5">
      <Label>Product Photo (Optional)</Label>
      <div className="flex items-center gap-3">
        {imageUrl ? (
          <div className="relative shrink-0">
            <BomImage src={imageUrl} alt="preview" className="h-14 w-14" zoomable />
            <button type="button" onClick={() => onChange("")}
              className="absolute -top-1.5 -right-1.5 bg-white rounded-full border border-slate-200 text-slate-400 hover:text-red-500 shadow-sm"
              data-testid="bom-form-image-clear">
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        ) : (
          <div className="h-14 w-14 shrink-0 rounded-lg border border-dashed border-slate-300 flex items-center justify-center text-slate-300">
            <ImageIcon className="h-5 w-5" />
          </div>
        )}
        <div className="flex-1 min-w-0 space-y-1.5">
          <label className="inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-md border border-slate-200 bg-white text-slate-600 hover:border-blue-300 hover:text-blue-700 cursor-pointer transition-colors"
            data-testid="bom-form-image-upload">
            <Upload className="h-3.5 w-3.5" /> Upload from computer
            <input type="file" accept="image/*" className="hidden" onChange={onFile} data-testid="bom-form-image-file" />
          </label>
          <Input
            value={String(imageUrl).startsWith("data:") ? "" : imageUrl}
            onChange={(e) => onChange(e.target.value)}
            placeholder="…or paste an image URL"
            data-testid="bom-form-image"
          />
        </div>
      </div>
    </div>
  );
}
